"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.$search = void 0;
var _oldHttpClient = require("../../apiClient/oldHttpClient");
var base = '/search';
var $search = exports.$search = function $search() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var filters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var page = arguments.length > 2 ? arguments[2] : undefined;
  var subFilters = arguments.length > 3 ? arguments[3] : undefined;
  var limit = arguments.length > 4 ? arguments[4] : undefined;
  var url = base;
  if (query) {
    url += "?q=".concat(encodeURIComponent(query));
  }
  if (filters.length) {
    url += "".concat(query ? '&' : '?', "filters[]=").concat(filters.join('&filters[]='));
    if (subFilters) {
      Object.keys(subFilters).forEach(subFilter => {
        url += "&".concat(subFilter, "=").concat(encodeURIComponent(subFilters[subFilter]));
      });
    }
  }
  if (page) {
    var _url;
    url += "".concat(((_url = url) === null || _url === void 0 ? void 0 : _url.indexOf('?')) !== -1 ? '&' : '?', "page=").concat(page);
  }
  if (limit) {
    var _url2;
    url += "".concat(((_url2 = url) === null || _url2 === void 0 ? void 0 : _url2.indexOf('?')) !== -1 ? '&' : '?', "limit=").concat(limit);
  }
  return (0, _oldHttpClient.apiClient)({
    method: 'get',
    url,
    body: undefined
  });
};